module.exports = __webpack_public_path__ + "images/emoji/dart.281b91d014bb2d879edd.png";